import { fetchAsync } from '@engagehub/core';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { adminApiVersion } from '@utils/store/constants';
import { IConfigureAdoFields } from '../hooks';

export const useConfigureAdo = (): UseMutationResult<
  unknown,
  AxiosError,
  IConfigureAdoFields,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    (values: IConfigureAdoFields) =>
      fetchAsync(`/br-admin/datasource/ado`, {
        method: 'POST',
        headers: {
          'x-eh-scope': values.targetScope,
        },
        params: {
          'api-version': adminApiVersion,
        },
        data: {
          ...values,
          createdBy: 'Microsoft@microsoft.com',
        },
      }),
    {
      onSuccess: () => queryClient.invalidateQueries(['create-customer-process']),
    },
  );
};
